import axios from "axios";

export const getSuggestion = async (text, categoryId, tradeTypeId, cityId) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/search/suggest/${text}?categoryId=${categoryId}&tradeTypeId=${tradeTypeId}&cityId=${cityId}`;
  const response = await axios.get(url);
  return response.data;
};

export const getSuggestionForAgent = async (text) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/search/account/suggest?text=${text}`;
  const response = await axios.get(url);
  return response.data;
};

export const getSuggestionForProject = async (freeText) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/search/project/suggest/${freeText}`;
  const response = await axios.get(url);
  return response.data;
};
